import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import LButton from '@/components/core/Button.vue'
import { useSelectedTrip } from '@/composables/trip'
import type { Transportation } from '@/types/transportation'
import {
  demotesToStandalone,
  effectiveGroupLegCount,
} from '@/utils/transportation-group-sync'

interface AnchorState {
  enabled: boolean
}

interface Props {
  /** Transportation currently being edited (segment or standalone). */
  transportation?: Pick<Transportation, '_id' | 'type' | 'groupId'>
  /** Waypoint id where this transportation is anchored (origin WP). */
  waypointId?: string
  /**
   * Effective leg selection (draft from picker if any, else current group's
   * fromWaypointIds). Drives mode display.
   */
  selection?: string[]
  /** Effective arrival anchor state (draft if touched, else persisted flag). */
  arrival?: AnchorState
  /** Effective departure anchor state. */
  departure?: AnchorState
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UseForSection',
  props: {
    transportation: null,
    waypointId: null,
    selection: { default: () => [] },
    arrival: { default: () => ({ enabled: false }) },
    departure: { default: () => ({ enabled: false }) }
  },
  emits: ["open-picker"],
  setup(__props: any, { emit }: { emit: ({ (e: 'open-picker'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { transportation?: Pick<Transportation, '_id' | 'type' | 'groupId'>, waypointId?: string, selection: string[], arrival: AnchorState, departure: AnchorState };




function handleChange() {
  emit('open-picker')
}

const trip = useSelectedTrip()

const selectedCount = computed(() =>
  effectiveGroupLegCount({
    regularLegCount: props.selection.length,
    arrivalEnabled: props.arrival.enabled,
    departureEnabled: props.departure.enabled,
  }),
)

const mode = computed<'single' | 'multi'>(() =>
  demotesToStandalone(selectedCount.value) ? 'single' : 'multi',
)

const totalLegs = computed(
  () => Math.max(0, (trip.value?.waypoints.length ?? 0) - 1) + 2,
)

const singleLegSubtitle = computed(() => {
  const wps = trip.value?.waypoints ?? []
  const idx = wps.findIndex((wp) => wp._id === props.waypointId)
  if (idx === -1) {
    return ''
  }
  const from = wps[idx]
  const to = wps[idx + 1]
  if (!to) {
    return from?.name ?? ''
  }
  return `${from.name} → ${to.name}`
})

return { __sfc: true,props, emit, handleChange, trip, selectedCount, mode, totalLegs, singleLegSubtitle, LButton }
}

})